import type {
  PluginManifest,
  ResolvedPluginManifest,
  ResolvedToolbarConfig,
  ResolvedRouteConfig,
  ResolvedViewerConfig,
  ToolbarConfig,
  RouteConfig,
  ViewerConfig,
} from "@aspect/plugin-sdk";

export function resolveManifest(raw: PluginManifest): ResolvedPluginManifest {
  return {
    name: raw.name,
    id: raw.id,
    version: raw.version,
    sdk: raw.sdk,
    description: raw.description ?? "",
    author: raw.author ?? "",
    authorUrl: raw.authorUrl ?? "",
    icon: raw.icon ?? "",
    permissions: raw.permissions ?? [],
    networkAccess: raw.networkAccess,
    main: raw.main,
    toolbar: resolveToolbar(raw.toolbar),
    route: resolveRoute(raw.route),
    viewer: resolveViewer(raw.viewer),
  };
}

function resolveToolbar(
  config: string | ToolbarConfig | undefined
): ResolvedToolbarConfig | undefined {
  if (!config) return undefined;
  if (typeof config === "string") {
    return {
      path: config,
      title: "Plugin",
      icon: "puzzle",
      display: "popup",
    };
  }
  return {
    path: config.path,
    title: config.title ?? "Plugin",
    icon: config.icon ?? "puzzle",
    display: config.display ?? "popup",
    width: config.width,
    height: config.height,
  };
}

function resolveRoute(
  config: string | RouteConfig | undefined
): ResolvedRouteConfig | undefined {
  if (!config) return undefined;
  if (typeof config === "string") {
    return {
      path: config,
      title: "Plugin Page",
      icon: "puzzle",
    };
  }
  return {
    path: config.path,
    title: config.title ?? "Plugin Page",
    icon: config.icon ?? "puzzle",
  };
}

function resolveViewer(
  config: string | ViewerConfig | undefined
): ResolvedViewerConfig | undefined {
  if (!config) return undefined;
  if (typeof config === "string") {
    return {
      path: config,
      title: "Viewer",
      icon: "eye",
      urlPatterns: [],
    };
  }
  return {
    path: config.path,
    title: config.title ?? "Viewer",
    icon: config.icon ?? "eye",
    urlPatterns: config.urlPatterns,
  };
}
